import Navbar from 'react-bootstrap/Navbar'

import { useState, useEffect } from 'react';
import Button from 'react-bootstrap/Button';
import Offcanvas from 'react-bootstrap/Offcanvas';
import { PollAIJob, TehamaAI, TehamaAIImage } from "../LLM/OpenAI.js";
import LineGraph from '../Chart/LineChart.js';
import { sanitizeDateTime } from '../timeFunctions/timeFns.js';
import {meterImageDataURI} from './ImageUpload.js';

import './cmdLine.css'

export default function SideBar(props) {
  const [show, setShow] = useState(false);
  const [waiting, setWaiting] = useState(false)
  const [input, setInput] = useState('')
  const [session, setSession] = useState(crypto.randomUUID())
  const [cancelPoll, setCancel] = useState(new AbortController())
  const [aiChart, setaiChart] = useState([])
  const [attachment, setAttachment] = useState (undefined)

  const handleShow = () => {
    setCancel(new AbortController())
    setShow(true);
  }
  const handleClose = () => {
    cancelPoll.abort("User cancelled request")
    setShow(false)
  }
  
  const tryAI = (text) => {
    // const prom = Gemini(text) works, but generic
    //console.log (props, session)
   const prom = attachment ? TehamaAIImage (props, text, attachment) : TehamaAI(props, text, session)
    prom.then ((result) => {
      return result
    })
    .catch ((err) => { 
      displayText ("Error submitting job "+err.toString())
      console.log (err)
      return err
    })
    return prom
  }
  const displayText = (text) =>{
    const txtLog = document.getElementById('history')
    if (txtLog) {
      const safetxt = text ?? ""
      const prior = txtLog?.value ?? ""
      txtLog.value = "> " + safetxt + "\n"+prior
    }
  }
  const updateUI = (text) => {
    const safetxt = text ?? ""
    const blocks = safetxt.split("\nCHART_DATA:")
    displayText(blocks[0])
    if (blocks.length > 1) {
      try {
        setaiChart(JSON.parse(blocks[1]))
        // console.log ("yes json", chartData)
        showChart ('visible')
      }
      catch (err) {
        displayText ("Error parsing data block "+ err?.toString())
        console.log ("Error parsing data block", err)
      }
    }
    else
        showChart ('hidden')
  } 
  //
  const showChart = (state) => {
    const chartDiv = document.querySelector(".aiChart")
    if (chartDiv)
        chartDiv.style.visibility = state 
  }
  const handlePrompt = (text) => {
    setWaiting(true)
    try {
      const resp = tryAI (text)
      resp.then (async (result) => {
        const jobId = result?.data?.jobId
        if (jobId) {
          const aiResp = await PollAIJob(props, jobId, cancelPoll)
          updateUI (aiResp?.data?.response)
          resetInput()
        }
        else {
          resetInput()
          displayText ("Error submitting job")
          console.log ("error submitting job")
        }     
      })
    }
    catch (err) {

    }
  }
  const resetInput = () => {
    setWaiting (false)
    setInput('')
    document.getElementById("cmdline").value = ''
  } 
  const getInput = (event) => {
    setInput(event.target.value)
    if (event.target.value.at(-1) === '\n') {
      handlePrompt(event.target.value)
    }
  }
  // chart wants two arrays: label[], holding dates and data[] = values to plot. 
  const aiToChart = (aiData) => {
    const arrData = aiData?.dataPoints ?? []
    const time = arrData.map(i => sanitizeDateTime(i?.timestamp))
    const plot = arrData.map(j => j?.value)
    return {label:time, data:plot}
  }
  const aiChartScale = (chart) => {
    const min = Math.min(...chart?.data ?? [0]) * 0.9
    const max = Math.max(...chart?.data ?? [1]) * 1.1
    return {yscale: {suggestedMin: min, suggestedMax: max}}
  }
  const fileHandler = async (event) => {
	//setSelectedFile(event.target.files[0]);
	const selected = event.target.files[0]
	if (selected) {
      if (selected.name.toLowerCase().endsWith(".jpg") || selected.name.toLowerCase().endsWith(".jpeg")) {
		    const encode = await meterImageDataURI(event.target.files[0]);
        setAttachment (encode)
        if (!encode)
          displayText ("Unable to encode image")
      }
      else {
        console.log ("commence rejection")
        displayText("Unable to process image type")
      }
	}
	// reset the input element
	event.target.value = ''
  }

  const chartData = aiToChart(aiChart)
  const yscale = aiChartScale(chartData)

  const bvar = 'primary' + (waiting?' disabled': '')
  const aiAllowed = ['tuser', 'davef-tuser', 'twdg66', 'jay-tuser', 'jim-tuser',
                    'jerry-tuser','anthony-tuser','prod-tuser', 'johnny-tuser']
  if (aiAllowed.includes (props.userLogin) && props?.getActiveSite())
  return (
    <>
      <Navbar.Text style={props.clickStyle} onClick={handleShow} className="navbar-spacer ">
        &gt;_
      </Navbar.Text>
      <Offcanvas show={show} onHide={handleClose} placement="end" id="aiCanvas">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Ask Tehama AI</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          Ask me anything. Your dialog will display below
        <textarea id="cmdline" name="cmdline" onChange={getInput}></textarea>
        <Button variant={bvar} onClick={()=>handlePrompt(input)}>Submit</Button>
        <input type="file" id="cameraInput" accept="image/jpeg" className="imageFile" onInput={fileHandler} onChange={fileHandler} />
        {waiting && <span className="pulse pplace"></span>}
        <hr />
        <textarea className='aiHistory' id='history'></textarea>
        <LineGraph {...chartData} {...yscale} container="aiChart"/>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  )
  else return null
}
// document.getElementById("cmdline").value
//button style className='btn-outline-light nav-flyout' 
